<template>
    <div class="popover-copy">
        <div class="popover-header">
            <span class="pr-30">Danie <i>{{food.name}}</i></span>
            <button type="button" aria-label="Close" class="close"><span aria-hidden="true" v-close-popover>×</span>
            </button>
        </div>
        <div class="popover-body">
                <scrollable-select @change="selectedDay = $event.value">
                  <template v-slot:options>
                    <option v-for="day in availableDays" v-bind:value="day">
                      <template v-if="MENU_MODE">
                        {{day.name()}}
                      </template>
                      <template v-else>
                        {{ 'app.day' | trans }} {{ getDayIndexById(day.id) + 1 }}
                      </template>
                    </option>
                  </template>
                </scrollable-select>
            <div v-if="selectedDay">
                <label>Posiłek...</label><br>
                <select v-model="selectedPlan" class="form-control input-sm">
                    <option v-for="plan in availablePlans" v-bind:value="plan">
                        {{plan.name}}
                    </option>
                </select>
            </div>
        </div>
        <div class="popover-footer">
            <button :disabled="selectedDay === null || selectedPlan === null" class="btn btn-success" @click="copy" v-close-popover>Kopiuj</button>
            <button class="btn btn-default" v-close-popover>Zamknij</button>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapMutations, mapState } from 'vuex';
  import {trans} from '../../app';
  import { copyFood } from '../../services/CopyMenuDay';
  import { createDateTime, FORMAT_TIMESTAMP } from '../../utils/dateFormatter';
  import { multiPortionFoodsManager} from "../../services/MultiPortionFoodsManager";

  export default {
    props: [
      'dayId', 'planId', 'foodId',
    ],
    created() {
      this.day = this.getDayById(this.dayId);
      this.plan = this.day.getPlan(this.planId);
      this.food = this.plan.getFood(this.foodId);
    },
    data() {
      return {
        plan: null,
        selectedDay: null,
        selectedPlan: null,
      };
    },
    computed: {
      ...mapState({
        menu(state) {
          return state.menu;
        },
        days(state) {
          if (state.menu.schema)
            return state.menu.schema.days;
        },
        schema: state => state.menu.schema,
      }),
      ...mapGetters(['getDayById', 'MENU_MODE', 'getDayIndexById']),
      availableDays() {
        return this.days;
      },
      availablePlans() {
        return this.selectedDay.plans.filter(p => !p.findFood(this.food.hash, 'hash'));
      },
    },
    methods: {
      ...mapMutations([
        'checkFoodRepetition',
      ]),
      copy() {
          let newFood;
          if (this.food.isMultiPortionFood()) {
              newFood = multiPortionFoodsManager.copyMultiPortionFood(this.food, this.schema);
          } else {
              newFood = copyFood(this.food);
          }

        newFood.date = createDateTime(this.day.date, this.selectedPlan.time).format(FORMAT_TIMESTAMP);
        newFood.repeating = newFood.repeating.filter(d => d !== newFood.date);

        this.selectedPlan.addFood(newFood);

        this.checkFoodRepetition(newFood);

        if (newFood.isMultiPortionFood() && newFood.portion.amount !== this.food.portion.amount) {
            this.$toast(trans('app.food_copied_portions_reduced'));
        } else {
            this.$toast.success(trans('app.food_copied'));
        }

        this.selectedDay = null;
      },
    },
  };
</script>

